<script lang="ts" setup>
import type { Emitter } from 'mitt'

const emit = defineEmits<{
  (e: 'submit'): void
}>()

function onClick() {
  emit('submit')
}
</script>

<template>
  <div class="m-mention">
    <div class="m-mention__button" @click="onClick">
      <slot />
    </div>
  </div>
</template>
